'use strict';

cpntMap.set('awe-class-of-trade-filters', {
  props:{
    values:{type: Array, default: ()=>{ return [] }},
    // icon for bar category. Value must match an existing awe-font glyph.
    barIcon: {type: String, default: 'glass'}
  },
  data: function(){
    return {
      selectedItems:[],
      i18n: window.i18n,
    }
  },
  emits: ['avails-facet-change'],
  watch:{
    selectedItems:function(newVal){
      //console.log('selectedItems', newVal)
      this.$emit('avails-facet-change', { key: 'class-of-trade', values: newVal })
    }
  },
  mixins:[ i18nUpdateMixin ],
  methods:{
    getIconName:function(item){
      let name = ''
      switch(item){
        case 'store':
          name = 'basket'
          break
        case 'restaurant':
          name = 'restaurant'
          break
        case 'entertainment':
          name = 'ticket'
          break
        case 'bar':
          name = this.barIcon || 'glass'
          break
        case 'other':
          name = 'asterisk'
          break
      }
      return 'icon-' + name
    },
    handleKeyPress: function(event, item) {
      event.preventDefault()
      const checkbox = document.getElementById('cot-' + item)
      if (checkbox) 
        checkbox.click()
    },
    clearFilters:function(){
      this.selectedItems = []
    }
  },
  template: `
  <div class="cot-filters">
    <div class="cot-filter" v-for="item in values" :key="item">

      <input type="checkbox" :id="'cot-'+item" :value="item" v-model="selectedItems">
      <label :for="'cot-'+item"
      @keydown.enter="handleKeyPress($event, item)"
      :aria-label="i18n.getString(\`COT_FILTERS_\${item.toUpperCase()}\`)"
      tabindex="0"
      >
          <i :class="getIconName(item)"></i>

        </label>
    </div>
    <button 
      :disabled="!selectedItems.length" 
      class="clear-button"
      :aria-label="i18n.getString('COT_FILTERS_CLEAR')"
      @click="clearFilters"
    >
      <i class="icon-cancel"></i>
    </button>

  </div>`
})
